import ReactButton from 'components/Buttons/ReactButton';
import DefaultModal from 'components/Modal/DefaultModal';
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import AccountService from 'views/CRM/Account/services/accountService';
import SendEmailModal from '../../../SendEmailModal/';
import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../../../../../../assets/styles/table_custom_style';

const ContactsModal = ({
  accountId,
  recordTypeId,
  isModalOpen,
  isToGetContacts,
  opportunityData,
  onModalToggle
}) => {
  const [contacts, setContacts] = useState([]);
  const [emailInfoOpportunity, setEmailInfoOpportunity] = useState('');
  const [isModalSendEMailOpportunityOpen, setIsModalSendEmailOpportunityOpen] =
    useState(false);

  useEffect(() => {
    if (isToGetContacts) {
      AccountService.getById(recordTypeId, accountId)
        .then((response) => {
          console.log('Resposta =>', response);
          const contacts = response.data.data.contacts.filter(
            (contact) => contact.email
          );
          setContacts(contacts);
        })
        .catch((error) => {
          console.log('Erro', error);
        });
    }
  }, [isToGetContacts, recordTypeId, accountId]);

  function handleEmailMessage(email) {
    if (!email) return;

    setEmailInfoOpportunity(email);
    setIsModalSendEmailOpportunityOpen(!isModalSendEMailOpportunityOpen);
    return emailInfoOpportunity;
  }

  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'name',
        text: 'Nome',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => {
          return row.name;
        }
      },
      {
        dataField: 'email',
        text: 'Email',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => {
          if (row) return row.email;
        }
      },
      {
        dataField: 'action',
        text: 'Ações',
        style: icon_column_style,
        headerStyle: individual_icon_header_style,
        formatter: (_, row) => {
          return (
            <>
              <ReactButton
                btnColor="primary"
                onClick={() => handleEmailMessage(row.email)}
                disabled={!row.email}
              >
                <i className="fas fa-envelope" style={{ marginRight: '6px' }} />
                Enviar email
              </ReactButton>
            </>
          );
        }
      }
    );

    return [...columns];
  };

  const formattedColumns = createDynamicColumns();

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Escolher contato"
      showCloseButton={false}
      modalContainerClasses="modal-lg"
    >
      <ToolkitProvider
        data={contacts || []}
        keyField="id"
        columns={formattedColumns}
      >
        {(props) => (
          <div className="py-4 table-responsive">
            <BootstrapTable
              {...props.baseProps}
              bootstrap4={true}
              bordered={false}
              classes="align-items-center"
            />
          </div>
        )}
      </ToolkitProvider>
      <SendEmailModal
        opportunityEmail={emailInfoOpportunity}
        opportunityId={opportunityData.id}
        isModalOpen={isModalSendEMailOpportunityOpen}
        onModalToggle={setIsModalSendEmailOpportunityOpen}
        setIsModalOpen={setIsModalSendEmailOpportunityOpen}
      />
    </DefaultModal>
  );
};

export default ContactsModal;
